import { APIClient } from "../helpers/api_helper";

import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getChat = () => api.get(url.GET_CONVERSATION, {});

export const getChatDetail = (id: string) => api.get(`${url.GET_CONVERSATION}/${id}`, {});
export const deleteChat = (id: string) => api.delete(`${url.GET_CONVERSATION}/${id}`, {});
export const toggleEnableSuggestion = (id: string, payload: any) => api.put(`${url.GET_CONVERSATION}/${id}/enable-suggestion`, payload);
export const toggleDisplayNotes = (id: string, payload: any) => api.put(`${url.GET_CONVERSATION}/${id}/enable-display-notes`, payload);

export const SendMessage = (payload: any) => api.create(`${url.SEND_MESSAGE}/${payload.conversationId}/message/outgoing`, payload);

export const SendMessageWithoutConversation = (payload: any) => api.create(`${url.SEND_MESSAGE}/message/outgoing`, payload);

export const updateStatusMessage = (messageId: string) => api.put(`${url.UPDATE_MESSAGE}/${messageId}/update-status`, {});

export const createActivityNotes = (contactId: string): Promise<any> => api.get(`${url.CREATE_NOTE_ACTIVITIES}/${contactId}`, {});
export const getByContactId = (contactId: string): Promise<any> => api.get(`${url.GET_CONVERSATION}/by-contact/${contactId}`, {});
